import { Autocomplete, TextField } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { v2theme } from "../../../../styles/Theme";

interface DistrictSearchProps {
  options: string[];
  selected?: string;
  onChange: (e: any) => void;
  onAutoCompleteChange: (e: any, value: string | null) => void;
  onSelect: (e: any) => void;
}

const useStyle = makeStyles((theme) => ({
  gridItem: {
    padding: "0px !important",
  },
  inputText: {
    "& .MuiOutlinedInput-root": {
      "&:hover fieldset": {
        borderColor: v2theme.palette.primary.main,
      },
      "&.Mui-focused fieldset": {
        borderColor: v2theme.palette.primary.main,
      },
    },
  },
}));

export const DistrictSearch = (props: DistrictSearchProps) => {
  const classes = useStyle();
  return (
    <Autocomplete
      className={classes.inputText}
      freeSolo
      fullWidth
      disableClearable
      inputValue={props.selected}
      options={props.selected?.trim() === "" ? [] : props.options}
      onSelect={props.onSelect}
      onChange={props.onAutoCompleteChange}
      renderInput={(params) => (
        <TextField
          {...params}
          label="District"
          placeholder="Search or enter a district"
          InputProps={{
            ...params.InputProps,
          }}
          required
          fullWidth
          onChange={props.onChange}
        />
      )}
    />
  );
};
